export default "__VITE_ASSET__BkrDXn8c__"